/* TCI ADD FILE */

'use strict';

window.addEventListener('DOMContentLoaded', () => {

  const cartCounter = document.getElementsByClassName('cart-item-count-header--quantity')[0];
  const config = { attributes: true };
  const observer = new MutationObserver(addToCartFormSubmit);
  observer.observe(cartCounter, config);
  
});


/**
*
* カート追加時に特典を付与する関数
*
*/
async function addToCartFormSubmit() {

  const userLocation = await getUserLocation();
  const listBenefits =[];
  const updateJsRequestBody = {updates: {}};
  const addJsRequestBody = {items: []};

  const cartJson = await getCartJson();

  const benefits = getSpecificCartItems(cartJson.items,'_benefits_type','特典商品');
  const productsWithBenefits = getSpecificCartItems(cartJson.items,'_benefits_type','特典対象商品');

  if (BENEFITS_METADATA.length !== 0) {
    const benefitsGroup = [];
    for (const benefit of BENEFITS_METADATA) {
      const benefitInfo = {
        variant_id: benefit.variant_id,
        handle: benefit.handle,
        inventory_quantity: benefit.inventory_quantity,
        product_type: benefit.product_type,
        base_price__from: benefit.base_price__from,
        base_price__to: benefit.base_price__to,
        base_grant_quantity: benefit.base_grant_quantity,
        max_grant_quantity: benefit.max_grant_quantity,
        bonus_grant_quantity: benefit.bonus_grant_quantity,
        products_with_benefits: []
      };
      for (const lineItem of productsWithBenefits) {
        let price = 0;
        for (const variant of LIST_VARIANTS) {
          if (variant.variant_id == lineItem.variant_id) {
            price = variant.base_variant_price ? parseInt(variant.base_variant_price) : 0;
            break;
          }
        }
        const benefitHandles = lineItem.properties['_benefits_products'].replace(/\s+/g, '').split(',');
        if (benefitHandles.includes(benefit.handle)) {
          benefitInfo.products_with_benefits.push({
              variant_id: lineItem.variant_id,
              quantity: lineItem.quantity,
              price: lineItem.properties['_benefits_price']
            });
        }
      }
      benefitsGroup.push(benefitInfo);
    }
    
    for (const benefit of benefitsGroup) {
      const totalGrantQuantity = calcGrantQuantityForEachCondition(benefit);
      const variantIdsInCart = benefits.map(benefit => benefit.variant_id);
  
      if (variantIdsInCart.includes(benefit.variant_id)) {
        const benefitInCart = benefits.filter(item => item.variant_id === benefit.variant_id);
        if (benefitInCart[0].quantity !== totalGrantQuantity) {
          updateJsRequestBody.updates[benefit.variant_id] = totalGrantQuantity;
        }
        
      } else {
        if (totalGrantQuantity !== 0) {
          const properties = {
            _benefits_type: benefit.product_type
          }
          addJsRequestBody.items.push({id: parseInt(benefit.variant_id),quantity:totalGrantQuantity,properties:properties});
        }
      }
    }

    if (!isEmptyObject(updateJsRequestBody.updates)) {
      const result =  await fetchPostRequest('/cart/update.js',updateJsRequestBody);
    } else {
      //何もしない
    }
  
    if (addJsRequestBody.items.length !== 0) {
      const result = await fetchPostRequest('/cart/add.js',addJsRequestBody);
    } else {
      //何もしない
    }
  
    
  } else {
    //何もしない
  }
  
}

